import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

export class Lang {
    name: string;
    locale: string;
}

@Injectable({
    providedIn: 'root',
})
export class LocaleService {

    private static POWER_CLOUD_LANG_KEY = 'power.cloud.lang';

    static languages: Lang[] = [
        {
            name: 'Italiano',
            locale: 'it-IT'
        },
        {
            name: 'English',
            locale: 'en-US'
        }
    ];

    constructor(
        private translate: TranslateService
    ) {
    }

    setDefaultLang(language?: Lang | string): Lang {
        let _language;

        if (!language) {
            const storedLocale = localStorage.getItem(LocaleService.POWER_CLOUD_LANG_KEY);
            const storedLang = LocaleService.languages.filter(l => l.locale === storedLocale)[0];

            if (!storedLang) {
                localStorage.removeItem(LocaleService.POWER_CLOUD_LANG_KEY);
            }

            _language = storedLang || window.navigator.language;
        } else {
            _language = language;
        }

        _language = typeof _language === 'object' ? _language : {name: null, locale: _language};

        this.translate.setDefaultLang(_language.locale);
        localStorage.setItem(LocaleService.POWER_CLOUD_LANG_KEY, _language.locale);

        return _language;
    }
}
